var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.supportsRefresh
        ? _c(
            "v-toolbar",
            { attrs: { flat: "", dense: "", color: "secondary", dark: "" } },
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", loading: _vm.loading },
                  on: { click: _vm.refresh },
                },
                [_c("v-icon", [_vm._v("refresh")])],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("StationMap", {
        attrs: {
          allStations: _vm.dataSourceLocations,
          zoom: _vm.zoom,
          height: _vm.height,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }